import PropTypes from 'prop-types';
import React from 'react';
import Ad from '../common/ad';
import MediaQuery from '../common/media_query';

const OUT_OF_PAGE_AD_REFRESH_RATE_PER_SLIDE = 3;

const OutOfPageAd = ({ adsState, position = 'interstitial', className = 'out-of-page-ad', uniqueId = 'out-of-page', breakPoint = 'notMobile' }) => (
  <MediaQuery breakpoint={breakPoint}>
    <div className="oop-ad-unit-container">
      <Ad outOfPage
        adsState={adsState}
        position={position}
        className={className}
        uniqueId={uniqueId}
        refreshEveryNSlides={OUT_OF_PAGE_AD_REFRESH_RATE_PER_SLIDE}
        shouldDisplayImmediately
      />
    </div>
  </MediaQuery>
);

OutOfPageAd.propTypes = {
  adsState: PropTypes.object.isRequired,
  position: PropTypes.string,
  className: PropTypes.string,
  breakPoint: PropTypes.string,
  uniqueId: PropTypes

};

export default OutOfPageAd;
